import { Component, Input, OnChanges, SimpleChanges, OnInit} from '@angular/core';
import { NgClass } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AfTranslateFactory } from '@shared/modules/translate/factory/translate.factory';
import { AfTranslatePipe } from '@shared/modules/translate/pipe/af-translate.pipe';
import { AfTranslateDirective } from '@shared/modules/translate/directive/af-translate.directive';
import { ColorsPipe } from '@shared/filters/colors/colors.pipe';
import { CommonUtilsService } from '@shared/services/common-utils/common-utils.service';
import { CustomizeFieldsSwitchFormComponent } from "../customize-fields-switch-form/customize-fields-switch-form.component";
import { FieldTypeSwitchComponent } from "../../../shared/components/field-type-switch/field-type-switch.component";
import { FieldTypeListExtendedComponent } from "../../../shared/components/field-type-list-extended/field-type-list-extended.component";
import { CustomizeFieldsFactory } from '@shared/factories/customize-fields/customize-fields.factory';
import { InputNumberModule } from 'primeng/inputnumber';
import { MenuModule } from 'primeng/menu';
import { DragDropModule, moveItemInArray } from '@angular/cdk/drag-drop';

@Component({
    selector: 'customize-field-list',
    templateUrl: './customize-field-list.component.html',
    standalone: true,
    imports: [
      NgClass,
      FormsModule,
      AfTranslatePipe,
      AfTranslateDirective,
      ColorsPipe,
      CustomizeFieldsSwitchFormComponent,
      FieldTypeSwitchComponent,
      FieldTypeListExtendedComponent,
      InputNumberModule,
      MenuModule,
      DragDropModule
    ]
})
export class CustomizeFieldListComponent implements OnInit, OnChanges {
  requireText: string = this.translate.instant('customize-field.message-required-list');
  valueText: string = this.translate.instant('customize-field.message-value-text')
  customizeFieldList: any = {
    showNewListValue: false,
    errorListElements: false,
    errorEmptyList: false,
    newListValue: {
      text:'',
      isDefaultValue: false,
      listValueId: this.commonUtilsService.createNumberId(),
      newItem: true
    },
    maxlength: 50,
    selectedTypeList: 'default',
    typeListField: {
      label: this.translate.instant('customize-field-list.type-list'),
    },
    typeList: [
      {
        text: this.translate.instant('customize-field-list.dropdown-list'),
        listValueId: 'default',
      },
      {
        text: this.translate.instant('customize.extend-list'),
        listValueId: 'extendedList',
      },
      {
        text: this.translate.instant('customize.numerical-scale'),
        listValueId: 'numericalScale',
      }
    ],
    listColors: this.customizeFieldsFactory.getListValueColors(),
  }
  constructor(
    private translate: AfTranslateFactory,
    private commonUtilsService: CommonUtilsService,
    private customizeFieldsFactory: CustomizeFieldsFactory
    ) {}
  @Input() field: any = null;
  @Input() isPrivate: any = null;
  @Input() hiddenInLandings: boolean = false;
  @Input() concept: any = null;
  @Input() typeView: string = 'normal';
  @Input() previewMode: boolean = false;
  @Input() actionType: string = 'edit';

  ngOnInit(): void {
    this.customizeFieldList.showNewListValue = this.actionType === 'create'?true:false;
    this.customizeFieldList.newListValue.color = this.customizeFieldList.listColors[0]?.color ?? '';
    if(this.previewMode){
      this.customizeFieldList.typeListField.noEditable = true;
    }
  }

  ngOnChanges(changes:SimpleChanges): void{
    let that: any = this.customizeFieldList;
    that.disabledFormConfiguration = this.concept?.disabled || this.previewMode;
    if(changes['field'] && changes['field'].currentValue){
      that.field = changes['field'].currentValue;
      if(!that.field.fieldAttributes){
        that.field.fieldAttributes = {
          extendedList: that.field.extendedList,
          numericalScale: that.field.numericalScale,
          isManagerClassificator: that.field.isManagerClassificator
        };
      }
      if(that.field.extendedList){
        that.maxlength = 2000;
      }
      if (this.typeView !== 'translationsViewEditable' && this.typeView !== 'translationsViewNoEditable') {
        this.isHighlight();
      }
      if(that.field.fieldTypeId === 'listp'){
        that.field.isOpen = false;
      }
      if(that.field.extendedList){
        this.customizeFieldList.selectedTypeList = 'extendedList';
      }else{
        this.customizeFieldList.selectedTypeList = that.field.numericalScale? 'numericalScale' : 'default';
      }

    }
    if (this.typeView === 'translationsViewEditable') {
      this.checkErrorsListValues();
    }
  }

  isHighlight(){
    let field: any = this.customizeFieldList.field;
    if(field.isHighlight === true){
        field.multiple = false;
        field.isOpen = false;
        field.fieldAttributes.numericalScale = false;
        field.numericalScale =  field.fieldAttributes.numericalScale;
        field.listValues.forEach((listValue:any) => {
          if(!listValue.color || listValue.color === ''){
            listValue.color = this.customizeFieldList.listColors[0].color;
          }
        });
    }
  }

  closeNewListValue(){
    this.customizeFieldList.showNewListValue = !this.customizeFieldList.showNewListValue;
    this.resetDefaultListValue();
  }

  resetDefaultListValue(){
    this.customizeFieldList.newListValue = {
      text:'',
      isDefaultValue: false,
      color: this.customizeFieldList.listColors[0].color,
      listValueId: this.commonUtilsService.createNumberId(),
      newItem: true
    }
  }

  saveNewListValue(listValue:any){
    if(!this.checkErrorListValue(listValue)){
      if(listValue.isDefaultValue && !this.customizeFieldList.field.multiple){
        this.resetDefaultValue();
      }
      if(this.customizeFieldList.field.isHighlight){
        if(!listValue.color){
          listValue.color = this.customizeFieldList.listColors[0].color;
        }
      }
      this.customizeFieldList.field.listValues.push(this.customizeFieldList.newListValue);
      this.customizeFieldList.errorEmptyList = false;
      this.closeNewListValue();
    }
  }

  checkErrorListValue(listValue: any){
    this.checkDataValue(listValue, 'text');
    if(this.customizeFieldList.field.fieldTypeId === 'listp'){
      this.checkDataValue(listValue, 'weight');
    }
    return Boolean(listValue.error || listValue.errorWeight);
  }

  resetDefaultValue(){
    this.customizeFieldList.field.listValues.forEach((listValue:any) => {
      listValue.isDefaultValue = false;
    });
  }

  deleteListValue(listValue:any){
    this.customizeFieldList.field.listValues = this.commonUtilsService.deleteElement( listValue, this.customizeFieldList.field.listValues, 'text')
    this.customizeFieldList.showNewListValue = !(Boolean(this.customizeFieldList.field.listValues?.length));
    this.checkErrorsListValues();
  }

  checkErrorsListValues(){
    let listValueError = this.customizeFieldList.field.listValues.find((listValue: any) => (listValue.error || listValue.errorWeight))
    this.customizeFieldList.errorListElements = Boolean(listValueError);
  }

  selectDefaultValue(listValue:any){
    if(!listValue.isDefaultValue && !this.customizeFieldList.field.multiple){
      this.resetDefaultValue();
      if(this.customizeFieldList.showNewListValue){
        this.customizeFieldList.newListValue.isDefaultValue = false;
      }
    }
    listValue.isDefaultValue = !listValue.isDefaultValue;
  }

  selectColor(color:any, listValue:any){
    listValue.color = color.color;
  }

  addDataValue(listValue:any, type:any='text', e:any){
    if(e.keyCode === 13){
      this.checkDataValue(listValue, type);
    }
  }

  checkDataValue(listValue:any, type:any='text'){
    let that: any = this.customizeFieldList;
    if(type === 'text'){
      delete listValue.error;
      delete listValue.errorType;
      if(!listValue?.text){
        listValue.errorType = 'generic';
      }else if(that.field.numericalScale && (listValue && !this.commonUtilsService.checkIsIntegerNumber(listValue.text))){
        listValue.errorType = 'numericalScale';
      }else if(listValue?.text.length < 3 && !that.field.numericalScale){
        listValue.errorType = 'requiredCharacters';
      }else{
        that.field.listValues.forEach((element:any) => {
          if(element.text === listValue.text && element.listValueId !== listValue.listValueId){
            listValue.errorType = 'duplicateName';
          }
        })
      }
      listValue.error = Boolean(listValue.errorType);
    }else if(type === 'weight'){
      listValue.errorWeight = this.errorWeight(listValue);
    }
    this.checkErrorsListValues();
  }

  errorWeight(listValue:any){
    if(this.customizeFieldList.field.fieldTypeId === 'listp' && listValue && typeof listValue.weight !== 'number'){
      return true;
    }
    return false;
  }

  changeOptionOn(e:any, type:string){
    let that: any = this.customizeFieldList;
    switch(type){
      case 'typeList':
        let previousNumericalScale: boolean = that.field.numericalScale && e.newValue !== 'numericalScale';
        that.field.extendedList = e.newValue === 'extendedList'?true:false;
        that.field.numericalScale = e.newValue === 'numericalScale'?true:false;
        that.field.fieldAttributes.extendedList = that.field.extendedList;
        that.field.fieldAttributes.numericalScale = that.field.numericalScale;
        if(e.newValue === 'numericalScale'){
          this.checkNumericalScale(true);
        }else if(e.newValue === 'extendedList'){
          this.checkExtendList(true);
        }
        if(previousNumericalScale){
          this.resetErrorValues();
        }
        break;
      case 'multiple':
        that.field[type] = e.newValue;
        this.resetDefaultValue();
        this.customizeFieldList.newListValue.isDefaultValue = false;
        break;
      case 'isManagerClassificator':
        that.field[type] = e.newValue;
        that.field.fieldAttributes.isManagerClassificator = e.newValue;
        if(e.newValue){
          that.field.multiple = false;
          that.field.required = true;
        }
        break
      default:
        that.field[type] = e.newValue;
        break;
    }
  }

  checkExtendList(newValue:boolean){
    let that: any = this.customizeFieldList;
    that.field.fieldAttributes.extendedList = newValue;
    if(newValue){
      that.field.isOpen = false;
      that.field.isHighlight = false;
      that.field.fieldAttributes.numericalScale = false;
      that.field.numericalScale = that.field.fieldAttributes.numericalScale;
      that.maxlength = 2000;
    }else{
      that.maxlength = 50;
      that.newListValue.text = that.newListValue.text.substring(0,50);
    }
  }

  checkNumericalScale(newValue:boolean){
    let field: any = this.customizeFieldList.field;
    field.fieldAttributes.numericalScale = newValue;
    if(newValue){
      field.isOpen = false;
      field.isHighlight = false;
      field.multiple = false;
      field.extendedList = field.fieldAttributes.extendedList;
      if(this.customizeFieldList.newListValue.text?.length){
        this.checkElementValueNumericalScale(this.customizeFieldList.newListValue);
      }
      this.checkNumericalValues();
      this.checkExtendList(false);
      this.checkErrorsListValues();
    }
  }

  checkNumericalValues(){
    this.customizeFieldList.field.listValues.forEach((listValue:any) => {
      this.checkElementValueNumericalScale(listValue);
    });
  }

  checkElementValueNumericalScale(listValue: any){
    let isIntegerNumber: boolean = this.commonUtilsService.checkIsIntegerNumber(listValue.text);
    listValue.error = !(isIntegerNumber);
    listValue.errorType = listValue.error?'numericalScale':undefined;
  }

  resetErrorValues(){
    this.customizeFieldList.errorListElements = false;
    this.customizeFieldList.field.listValues.forEach((listValue:any) => {
      if(listValue.errorType === 'numericalScale'){
        delete listValue.error;
        delete listValue.errorType;
      }
    });
  }

  toggleFilter(e: any, menu: any){
    if(!this.customizeFieldList.disabledFormConfiguration){
      this.commonUtilsService.toggleFilterOverlay(e, menu, 'menu');
    }
  }

  reorderContainer(event: any){
    moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
  }

  validateSave(){
    if(this.customizeFieldList.field.listValues?.length){
      if(this.customizeFieldList.errorListElements){
        return false;
      }
    }else{
      this.customizeFieldList.errorEmptyList = true;
      return false;
    }
    return true;
  }
}
